"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOneTrustGlobally = void 0;
const constants_1 = require("./constants");
/**
 * Sets a global property '__oneTrustEnabled' on window object based on whether oneTrust experiment is enabled for the application.
 * This method needs to be called by the applications utilizing this package before oneTrust/adobe launch script
 * is included on their pages.
 * Once, we cleanup the experiment, this method will be removed and reliance on __oneTrustEnabled property of window
 * object will be removed as well from all the util methods of this library.
 * @param isOneTrustEnabled boolean - whether oneTrust is enabled, determined based on experiment - privacy_compliance_onetrust
 */
const setOneTrustGlobally = (isOneTrustEnabled) => {
    window[constants_1.ONETRUST_ENABLED] = isOneTrustEnabled;
};
exports.setOneTrustGlobally = setOneTrustGlobally;
